<template>
  <div class="home">
    <h2>Admin sayfasına hoş geldiniz</h2>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
};
</script>
